(function() {
	'use strict';

	angular.module('taskApp').controller('MyTaskController', MyTaskController);

	MyTaskController.$inject = [ '$scope', '$state', '$location', 'MyTask', '$log',
			'$resource', 'GLOBAL_URL', '$base64','NgTableParams','$filter','FORMAT_DATE','$window','WF_TASK', 'CommonService'];

	function MyTaskController($scope, $state, $location, MyTask, $log, $resource, GLOBAL_URL, $base64,NgTableParams,$filter,FORMAT_DATE,$window,WF_TASK, CommonService) {
		var myTaskCtr = this;
	    myTaskCtr.fromCreatedDate = new Date();
	    myTaskCtr.toCreatedDate = new Date();
		var self = $scope;

		self.title = 'Danh sách công việc của tôi';
		self.WF_TASK = WF_TASK;
		myTaskCtr.popupDate = {'fromCreatedDate': false, 'tocreatedDate': false};

		myTaskCtr.transactionURLs = [];
		myTaskCtr.getTransactionURL = getTransactionURL;
		myTaskCtr.transactionURLs = CommonService.query({masterurl:'get-transaction-url'});
    	
		myTaskCtr.tableParams = new NgTableParams({
			page: 1,
			count: 20,
			sorting: { 'taskInstance.createdDate': 'desc' }
		},
		{
			total: 0,
			counts: [20, 40, 80],
			defaultSort: 'desc',
			getData: function(params) {
    		var param = {};
    		param['page'] = params.page();
    		param['size'] = params.count();
    		param['sort'] = params.sorting();
    		if (myTaskCtr.fromCreatedDate) {
    			param['fromCreatedDate'] = $filter('date')(myTaskCtr.fromCreatedDate, FORMAT_DATE);
    		}
    		
    		if (myTaskCtr.toCreatedDate) {
    			param['toCreatedDate'] = $filter('date')(myTaskCtr.toCreatedDate, FORMAT_DATE);
    		}
    		if (myTaskCtr.customerName) {
    			param['customerName'] = myTaskCtr.customerName
    		}
    		if (myTaskCtr.policyNum) {
    			param['policyNum'] = myTaskCtr.policyNum
    		}
    		if (myTaskCtr.txnId) {
    			param['txnId'] = myTaskCtr.txnId
    		}
    		return MyTask.query(param).$promise.then(function(result) {
    			params.total(result.totalElements);
				return result.content;;
			});         	
        }
		});
		
		myTaskCtr.clickPopupDate = function (name) {
			myTaskCtr.popupDate[name] = !myTaskCtr.popupDate[name];
		}
		
		function getTransactionURL(code) {
    		return _.result(_.find(myTaskCtr.transactionURLs, function(obj) {
    		    return obj.code === code;
    		}), 'name');
    	}
		
		myTaskCtr.openPolicyInfo = function(policyNum) {
    		var uri = myTaskCtr.getTransactionURL('TRANSACTION_MAIN');
    		var number = null;
    		if (policyNum) {
    			uri = uri.concat('/ga/history/#/constractInfo/');
    			number = $base64.encode(policyNum);
			}
    		uri = uri.concat(number);
			$window.open(uri, '_blank');
    	}

		myTaskCtr.inState = function(state) {
			return $state.includes(state);
		}
		

		//release my task
		myTaskCtr.releaseTask = function(taskId) {
			MyTask.release({
				taskId : taskId
			}, function(result) {
				myTaskCtr.search();
			})
		};
		
		myTaskCtr.search = function () {
			myTaskCtr.tableParams.page(1);
			myTaskCtr.tableParams.reload();
    	}
		
		myTaskCtr.search();
		myTaskCtr.redirectTo = function (url, txnId, taskId){
			if(url != '' && txnId != '' && taskId != '') {
				//window.location.href = GLOBAL_URL + url + '?txnId='+txnId+ '&taskId='+taskId;
				window.location.href = GLOBAL_URL + url + '/' + $base64.encode(txnId) + '/' + $base64.encode(taskId);
			}
		}
	}
})();
